/*
  Nyan Gear dealer locator — Leaflet + MarkerCluster.
  Reads dealer data from a JSON <script> injected by sections/dealer-map.liquid,
  plots clustered markers, keeps a scrollable/searchable list in sync, and can
  sort the list by distance from the visitor's location.
*/
(function () {
  var STATES = {
    'alabama': 'AL', 'alaska': 'AK', 'arizona': 'AZ', 'arkansas': 'AR', 'california': 'CA',
    'colorado': 'CO', 'connecticut': 'CT', 'delaware': 'DE', 'florida': 'FL', 'georgia': 'GA',
    'hawaii': 'HI', 'idaho': 'ID', 'illinois': 'IL', 'indiana': 'IN', 'iowa': 'IA', 'kansas': 'KS',
    'kentucky': 'KY', 'louisiana': 'LA', 'maine': 'ME', 'maryland': 'MD', 'massachusetts': 'MA',
    'michigan': 'MI', 'minnesota': 'MN', 'mississippi': 'MS', 'missouri': 'MO', 'montana': 'MT',
    'nebraska': 'NE', 'nevada': 'NV', 'new hampshire': 'NH', 'new jersey': 'NJ', 'new mexico': 'NM',
    'new york': 'NY', 'north carolina': 'NC', 'north dakota': 'ND', 'ohio': 'OH', 'oklahoma': 'OK',
    'oregon': 'OR', 'pennsylvania': 'PA', 'rhode island': 'RI', 'south carolina': 'SC',
    'south dakota': 'SD', 'tennessee': 'TN', 'texas': 'TX', 'utah': 'UT', 'vermont': 'VT',
    'virginia': 'VA', 'washington': 'WA', 'west virginia': 'WV', 'wisconsin': 'WI', 'wyoming': 'WY',
    'district of columbia': 'DC', 'washington dc': 'DC'
  };
  var ABBRS = {};
  for (var _s in STATES) { if (STATES.hasOwnProperty(_s)) ABBRS[STATES[_s].toLowerCase()] = 1; }

  function initMap(root, dealers) {
    dealers = (dealers || []).filter(function (d) {
      return typeof d.lat === 'number' && typeof d.lng === 'number' && !isNaN(d.lat) && !isNaN(d.lng);
    });

    var mapEl = root.querySelector('.dealer-map__canvas');
    var listEl = root.querySelector('.dealer-map__list');
    var searchEl = root.querySelector('.dealer-map__search-input');
    var countEl = root.querySelector('.dealer-map__count');
    var geoBtn = root.querySelector('[data-dealer-geo]');

    var map = L.map(mapEl, { scrollWheelZoom: false, zoomControl: true, zoomSnap: 0 }).setView([39.5, -98.35], 4);

    var tiles = L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>',
      subdomains: 'abcd',
      maxZoom: 19
    }).addTo(map);
    tiles.on('load', function () { hideLoader(root); });

    // Trackpad pinch (and ctrl+wheel) over the map = zoom the MAP, not the browser page.
    // Plain two-finger scroll (no ctrlKey) is left alone so the page still scrolls.
    mapEl.addEventListener('wheel', function (e) {
      if (!e.ctrlKey) return;
      e.preventDefault();
      var at = map.mouseEventToLatLng(e);
      map.setZoomAround(at, map.getZoom() - e.deltaY * 0.015, { animate: false });
    }, { passive: false });

    function pinIcon() {
      return L.divIcon({
        className: 'dealer-pin',
        html: '<span class="dealer-pin__body"></span>',
        iconSize: [28, 38], iconAnchor: [14, 36], popupAnchor: [0, -34]
      });
    }
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function popupHtml(d) {
      var dir = 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(d.address);
      var tel = (d.phone || '').replace(/[^\d+]/g, '');
      return '<div class="dealer-pop">' +
        '<strong class="dealer-pop__name">' + esc(d.name) + '</strong>' +
        '<span class="dealer-pop__addr">' + esc(d.address) + '</span>' +
        (d.phone ? '<a class="dealer-pop__phone" href="tel:' + tel + '">' + esc(d.phone) + '</a>' : '') +
        '<a class="dealer-pop__dir" href="' + dir + '" target="_blank" rel="noopener">Get directions →</a>' +
        '</div>';
    }
    // Great-circle distance in miles
    function miles(aLat, aLng, bLat, bLng) {
      var R = 3958.8, toRad = Math.PI / 180;
      var dLat = (bLat - aLat) * toRad, dLng = (bLng - aLng) * toRad;
      var s = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
              Math.cos(aLat * toRad) * Math.cos(bLat * toRad) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return R * 2 * Math.atan2(Math.sqrt(s), Math.sqrt(1 - s));
    }
    // Pull the 2-letter state from an address that ends "…, ST 12345"
    function extractState(a) {
      var m = (a || '').match(/,\s*([A-Za-z]{2})\s+\d{5}(?:-\d{4})?\s*$/);
      return m ? m[1].toUpperCase() : null;
    }

    var cluster = L.markerClusterGroup({ showCoverageOnHover: false, maxClusterRadius: 55, spiderfyOnMaxZoom: true });
    var rows = [];

    dealers.forEach(function (d, i) {
      var marker = L.marker([d.lat, d.lng], { icon: pinIcon(), title: d.name });
      marker.bindPopup(popupHtml(d), { closeButton: true });
      cluster.addLayer(marker);

      var li = document.createElement('button');
      li.type = 'button';
      li.className = 'dealer-map__item';
      li.innerHTML = '<span class="dealer-map__item-dist" hidden></span>' +
                     '<span class="dealer-map__item-name">' + esc(d.name) + '</span>' +
                     '<span class="dealer-map__item-addr">' + esc(d.address) + '</span>';
      li.addEventListener('click', function () { focusDealer(i); });
      listEl.appendChild(li);

      rows.push({ d: d, marker: marker, li: li, dist: null, idx: i,
                  state: extractState(d.address),
                  distEl: li.querySelector('.dealer-map__item-dist'),
                  hay: (d.name + ' ' + d.address).toLowerCase() });
    });

    map.addLayer(cluster);
    if (rows.length) map.fitBounds(cluster.getBounds().pad(0.15));

    function focusDealer(i) {
      var r = rows[i];
      if (!r) return;
      map.flyTo(r.marker.getLatLng(), 13, { duration: 0.6 });
      map.once('moveend', function () { r.marker.openPopup(); });
      rows.forEach(function (x) { x.li.classList.toggle('is-active', x === r); });
      r.li.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    // ---- Search by name / city / state / zip, never empty (nearest fallback)
    var noteEl = root.querySelector('.dealer-map__note');
    var origOrder = rows.slice();
    var searchTimer = null;

    function setNote(t) { if (noteEl) { noteEl.textContent = t || ''; noteEl.hidden = !t; } }

    function fitTo(markers) {
      if (!markers.length) return;
      var b = L.latLngBounds(markers.map(function (m) { return m.getLatLng(); }));
      map.flyToBounds(b.pad(0.25), { duration: 0.5, maxZoom: 12 });
    }

    function renderList(matchRows, note) {
      origOrder.forEach(function (r) { r.li.hidden = true; });
      matchRows.forEach(function (r) { r.li.hidden = false; listEl.appendChild(r.li); });
      if (countEl) countEl.textContent = matchRows.length + (matchRows.length === 1 ? ' dealer' : ' dealers');
      setNote(note);
    }

    function resetList() {
      origOrder.forEach(function (r) { r.li.hidden = false; r.distEl.hidden = true; listEl.appendChild(r.li); });
      if (countEl) countEl.textContent = origOrder.length + ' dealers';
      setNote('');
      map.flyToBounds(cluster.getBounds().pad(0.15), { duration: 0.4 });
    }

    function localMatches(q) {
      // Full state name ("california") or bare abbreviation ("ca") -> match the state token ", ca "
      // (trailing space = the code is followed by the ZIP, so it can't match ", Carlisle").
      var abbr = STATES[q] ? STATES[q].toLowerCase() : (q.length === 2 && ABBRS[q] ? q : null);
      if (abbr) {
        var token = ', ' + abbr + ' ';
        return origOrder.filter(function (r) { return r.hay.indexOf(token) !== -1; });
      }
      return origOrder.filter(function (r) { return r.hay.indexOf(q) !== -1; });
    }

    function nearestTo(lat, lng, n) {
      return origOrder.slice().sort(function (a, b) {
        return miles(lat, lng, a.d.lat, a.d.lng) - miles(lat, lng, b.d.lat, b.d.lng);
      }).slice(0, n);
    }

    // Geocode a query to point + bounding box + state (for zoom and city->state expansion)
    function geocode(q) {
      if (!window.fetch) return Promise.resolve(null);
      return fetch('https://nominatim.openstreetmap.org/search?format=json&addressdetails=1&countrycodes=us&limit=1&q=' + encodeURIComponent(q))
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (!res || !res.length) return null;
          var bb = res[0].boundingbox; // [south, north, west, east]
          var stName = ((res[0].address && res[0].address.state) || '').toLowerCase();
          return {
            lat: parseFloat(res[0].lat), lng: parseFloat(res[0].lon),
            state: STATES[stName] || null,
            box: bb ? [[parseFloat(bb[0]), parseFloat(bb[2])], [parseFloat(bb[1]), parseFloat(bb[3])]] : null
          };
        })
        .catch(function () { return null; });
    }

    function dealersInState(abbr) { return origOrder.filter(function (r) { return r.state === abbr; }); }
    function stateOfMatches(list) {
      if (!list.length) return null;
      var s = list[0].state;
      for (var i = 1; i < list.length; i++) { if (list[i].state !== s) return null; }
      return s;
    }

    // Runs once the visitor finishes typing.
    function finishSearch(q, raw) {
      var local = localMatches(q);
      geocode(q).then(function (loc) {
        var targetState = (loc && loc.state) || stateOfMatches(local);
        var inState = targetState ? dealersInState(targetState) : [];

        if (inState.length) {
          // City/name matches first, then the rest of that state
          var seen = {};
          var cityFirst = local.filter(function (r) { return r.state === targetState; });
          cityFirst.forEach(function (r) { seen[r.idx] = 1; });
          var rest = inState.filter(function (r) { return !seen[r.idx]; });
          var result = cityFirst.concat(rest);
          result.forEach(function (r) { r.distEl.hidden = true; });
          renderList(result, cityFirst.length ? '' : ('No dealers in “' + raw + '” — showing all of ' + targetState + '.'));
          if (loc && loc.box) map.flyToBounds(loc.box, { duration: 0.6, maxZoom: 13, padding: [24, 24] });
          else fitTo(result.map(function (r) { return r.marker; }));
        } else if (loc) {
          // Never empty: 5 closest to the searched place
          var near = nearestTo(loc.lat, loc.lng, 5);
          near.forEach(function (r) {
            var d = miles(loc.lat, loc.lng, r.d.lat, r.d.lng);
            r.distEl.textContent = (d < 10 ? d.toFixed(1) : Math.round(d)) + ' mi';
            r.distEl.hidden = false;
          });
          renderList(near, 'No dealers in “' + raw + '” yet — here are the 5 closest.');
          var b = L.latLngBounds(near.map(function (r) { return r.marker.getLatLng(); }));
          b.extend([loc.lat, loc.lng]);
          map.flyToBounds(b.pad(0.3), { duration: 0.6, maxZoom: 11 });
        } else if (local.length) {
          renderList(local, '');
          fitTo(local.map(function (r) { return r.marker; }));
        } else {
          renderList(origOrder, 'No match for “' + raw + '” — showing all dealers.');
          map.flyToBounds(cluster.getBounds().pad(0.15), { duration: 0.4 });
        }
      });
    }

    if (searchEl) {
      searchEl.addEventListener('input', function () {
        var raw = searchEl.value.trim(), q = raw.toLowerCase();
        clearTimeout(searchTimer);
        if (!q) { resetList(); return; }
        // filter the list instantly; zoom the map once typing settles
        var matches = localMatches(q);
        if (matches.length) renderList(matches, '');
        else setNote('Searching “' + raw + '”…');
        searchTimer = setTimeout(function () { finishSearch(q, raw); }, 500);
      });
    }
    if (countEl) countEl.textContent = rows.length + ' dealers';

    // ---- Nearest-to-me -------------------------------------------------------
    var userMarker = null;
    var inIframe = false;
    try { inIframe = window.self !== window.top; } catch (e) { inIframe = true; }
    function locateUser(fromButton) {
      if (!navigator.geolocation) { if (fromButton && geoBtn) geoBtn.textContent = '📍 Not supported here'; return; }
      if (geoBtn) geoBtn.setAttribute('data-loading', '1');
      navigator.geolocation.getCurrentPosition(function (pos) {
        var uLat = pos.coords.latitude, uLng = pos.coords.longitude;
        rows.forEach(function (r) {
          r.dist = miles(uLat, uLng, r.d.lat, r.d.lng);
          r.distEl.textContent = (r.dist < 10 ? r.dist.toFixed(1) : Math.round(r.dist)) + ' mi';
          r.distEl.hidden = false;
        });
        // sort list nearest-first
        rows.slice().sort(function (a, b) { return a.dist - b.dist; })
            .forEach(function (r) { listEl.appendChild(r.li); });

        if (userMarker) map.removeLayer(userMarker);
        userMarker = L.circleMarker([uLat, uLng], {
          radius: 8, color: '#1a73e8', fillColor: '#1a73e8', fillOpacity: 0.9, weight: 3
        }).addTo(map).bindPopup('You are here');

        // frame the user + 3 nearest dealers
        var nearest = rows.slice().sort(function (a, b) { return a.dist - b.dist; }).slice(0, 3);
        var b = L.latLngBounds(nearest.map(function (r) { return r.marker.getLatLng(); }));
        b.extend([uLat, uLng]);
        map.flyToBounds(b.pad(0.3), { duration: 0.8 });
        if (geoBtn) { geoBtn.removeAttribute('data-loading'); geoBtn.textContent = '📍 Sorted by nearest'; }
      }, function (err) {
        if (geoBtn) geoBtn.removeAttribute('data-loading');
        if (!fromButton) return;
        var msg = '📍 Location unavailable on this device';
        if (inIframe) msg = '📍 Open in a full browser tab to use location';
        else if (err && err.code === 1) msg = '📍 Allow location, then tap again';
        else if (err && err.code === 3) msg = '📍 Timed out — tap to retry';
        if (geoBtn) {
          geoBtn.textContent = msg;
          setTimeout(function () { geoBtn.textContent = '📍 Find nearest to me'; }, 6000);
        }
      }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 600000 });
    }

    if (geoBtn) geoBtn.addEventListener('click', function () { locateUser(true); });
    // Intentionally NO auto-locate on load — that caused a jarring zoom + blue
    // "you are here" dot before the visitor asked for it. They tap the button.

    setTimeout(function () { map.invalidateSize(); }, 300);
    // Safety net so the loading animation always clears (cached tiles may never fire 'load').
    setTimeout(function () { hideLoader(root); }, 3500);
  }

  // ---- Data source: live Google Sheet (name,address,phone,lat,lng) w/ baked-in fallback ----
  function parseCSV(text) {
    var rows = [], row = [], f = '', q = false;
    for (var i = 0; i < text.length; i++) {
      var c = text[i];
      if (q) { if (c === '"') { if (text[i + 1] === '"') { f += '"'; i++; } else q = false; } else f += c; }
      else if (c === '"') q = true;
      else if (c === ',') { row.push(f); f = ''; }
      else if (c === '\n') { row.push(f); rows.push(row); row = []; f = ''; }
      else if (c !== '\r') f += c;
    }
    if (f.length || row.length) { row.push(f); rows.push(row); }
    return rows;
  }

  function sheetUrl(id) {
    return 'https://docs.google.com/spreadsheets/d/' + id + '/gviz/tq?tqx=out:csv&tq=' + encodeURIComponent('select A,B,C,N,O');
  }

  function fetchSheet(url) {
    if (!window.fetch) return Promise.resolve(null);
    return fetch(url, { credentials: 'omit' }).then(function (r) {
      if (!r.ok) throw new Error('http');
      return r.text();
    }).then(function (txt) {
      var rows = parseCSV(txt);
      if (!rows.length) return null;
      var start = String(rows[0][0] || '').toLowerCase().indexOf('name') === 0 ? 1 : 0;
      var out = [];
      for (var i = start; i < rows.length; i++) {
        var r = rows[i];
        var name = String(r[0] || '').trim();
        var lat = parseFloat(r[3]), lng = parseFloat(r[4]);
        if (name && !isNaN(lat) && !isNaN(lng)) {
          out.push({ name: name, address: String(r[1] || '').trim(), phone: String(r[2] || '').trim(), lat: lat, lng: lng });
        }
      }
      return out;
    });
  }

  // ---- Loading animation: a motorcycle riding across the map until it's ready ----
  function showLoader(root) {
    var mapEl = root.querySelector('.dealer-map__canvas');
    if (!mapEl || mapEl.querySelector('[data-dealer-loader]')) return;
    mapEl.style.position = 'relative';
    var el = document.createElement('div');
    el.className = 'dealer-map__loader';
    el.setAttribute('data-dealer-loader', '1');
    el.innerHTML =
      '<div class="dealer-map__loader-inner">' +
        '<div class="dealer-map__road"><span class="dealer-map__moto">🏍️</span></div>' +
        '<p class="dealer-map__loader-text">Revving up the dealer map…</p>' +
      '</div>';
    mapEl.appendChild(el);
  }
  function hideLoader(root) {
    var el = root.querySelector('[data-dealer-loader]');
    if (!el || el.classList.contains('is-hidden')) return;
    el.classList.add('is-hidden');
    setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 600);
  }

  function boot() {
    var root = document.querySelector('[data-dealer-map]');
    if (!root || typeof L === 'undefined') return;
    if (root.dataset.mapReady) return;
    root.dataset.mapReady = '1';
    showLoader(root);

    var baked = [];
    try { baked = JSON.parse(document.getElementById('nyan-dealer-data').textContent); } catch (e) {}

    var id = (root.getAttribute('data-sheet-id') || '').trim();
    if (!id) { initMap(root, baked); return; }

    var done = false;
    var timer = setTimeout(function () { if (!done) { done = true; initMap(root, baked); } }, 4500);
    fetchSheet(sheetUrl(id)).then(function (live) {
      if (done) return; done = true; clearTimeout(timer);
      initMap(root, (live && live.length) ? live : baked);
    }).catch(function () {
      if (done) return; done = true; clearTimeout(timer);
      initMap(root, baked);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
